// Domain validation configuration
// Add or remove domains as needed for your company
export const ALLOWED_DOMAINS = [
  'enterpriseaigroup.com',
  // Add additional company domains here if needed
  // 'subsidiary.com',
  // 'partner-company.org'
];

export const validateUserDomain = (email: string): boolean => {
  if (!email) return false;
  const domain = email.split('@')[1];
  return ALLOWED_DOMAINS.includes(domain);
};

export const getDomainValidationMessage = (email: string): string => {
  if (!email) return "No email address provided.";
  
  const domain = email.split('@')[1];
  if (!domain) return "Invalid email format.";
  
  if (ALLOWED_DOMAINS.includes(domain)) {
    return `Access granted for ${domain} domain.`;
  }
  
  return `Access denied. Only the following domains are allowed: ${ALLOWED_DOMAINS.join(', ')}`;
};
